// Generate future dates dynamically
function getFutureDate(daysFromNow: number): string {
  const d = new Date()
  d.setDate(d.getDate() + daysFromNow)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export const mockKPIs = {
  revenueWeek: 4500,
  bookingsWeek: 18,
  occupancyRate: 78,
  totalStudents: 45,
}

export const mockLocations = [
  {
    id: '1',
    name: 'Estudio Norte',
    address: 'Av. Insurgentes 420',
    city: 'CDMX',
    type: 'studio',
    capacity: 15,
    is_active: true,
  },
  {
    id: '2',
    name: 'Parque Chapultepec',
    address: 'Sección 1, entrada principal',
    city: 'CDMX',
    type: 'park',
    capacity: 25,
    is_active: true,
  },
  {
    id: '3',
    name: 'Estudio Centro',
    address: 'Madero 85',
    city: 'CDMX',
    type: 'studio',
    capacity: 10,
    is_active: false,
  },
]

export const mockClassTypes = [
  {
    id: '1',
    name: 'Yoga Grupal Presencial',
    modality: 'presencial',
    duration: 60,
    price: 1,
    description: 'Clase grupal en estudio',
    is_active: true,
  },
  {
    id: '2',
    name: 'Yoga por Zoom',
    modality: 'virtual',
    duration: 60,
    price: 1,
    description: 'Clase en vivo por Zoom',
    is_active: true,
  },
  {
    id: '3',
    name: 'Clase Privada Presencial',
    modality: 'presencial',
    duration: 60,
    price: 1,
    description: 'Atención 1 a 1',
    is_active: true,
  },
]

export const mockSessions = [
  {
    id: '1',
    class_type_id: '1',
    location_id: '1',
    session_date: getFutureDate(1),
    start_time: '08:00',
    capacity: 15,
    spots_available: 5,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Estudio Norte',
  },
  {
    id: '2',
    class_type_id: '2',
    location_id: null,
    session_date: getFutureDate(1),
    start_time: '10:00',
    capacity: 50,
    spots_available: 12,
    status: 'active',
    zoom_link: 'https://zoom.us/j/123456789',
    class_name: 'Yoga por Zoom',
    location_name: 'Virtual',
  },
  {
    id: '3',
    class_type_id: '1',
    location_id: '2',
    session_date: getFutureDate(2),
    start_time: '09:00',
    capacity: 25,
    spots_available: 8,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Parque Chapultepec',
  },
  {
    id: '4',
    class_type_id: '2',
    location_id: null,
    session_date: getFutureDate(2),
    start_time: '18:00',
    capacity: 50,
    spots_available: 30,
    status: 'active',
    zoom_link: 'https://zoom.us/j/987654321',
    class_name: 'Yoga por Zoom',
    location_name: 'Virtual',
  },
  {
    id: '5',
    class_type_id: '1',
    location_id: '1',
    session_date: getFutureDate(3),
    start_time: '08:00',
    capacity: 15,
    spots_available: 15,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Estudio Norte',
  },
  {
    id: '6',
    class_type_id: '2',
    location_id: null,
    session_date: getFutureDate(3),
    start_time: '10:00',
    capacity: 50,
    spots_available: 45,
    status: 'active',
    zoom_link: 'https://zoom.us/j/111222333',
    class_name: 'Yoga por Zoom',
    location_name: 'Virtual',
  },
  {
    id: '7',
    class_type_id: '1',
    location_id: '2',
    session_date: getFutureDate(5),
    start_time: '09:00',
    capacity: 25,
    spots_available: 20,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Parque Chapultepec',
  },
  {
    id: '8',
    class_type_id: '2',
    location_id: null,
    session_date: getFutureDate(5),
    start_time: '19:00',
    capacity: 50,
    spots_available: 50,
    status: 'active',
    zoom_link: 'https://zoom.us/j/444555666',
    class_name: 'Yoga por Zoom',
    location_name: 'Virtual',
  },
  {
    id: '9',
    class_type_id: '1',
    location_id: '1',
    session_date: getFutureDate(7),
    start_time: '08:00',
    capacity: 15,
    spots_available: 3,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Estudio Norte',
  },
  {
    id: '10',
    class_type_id: '1',
    location_id: '1',
    session_date: getFutureDate(7),
    start_time: '17:00',
    capacity: 15,
    spots_available: 10,
    status: 'active',
    class_name: 'Yoga Grupal Presencial',
    location_name: 'Estudio Norte',
  },
  {
    id: '11',
    class_type_id: '2',
    location_id: null,
    session_date: getFutureDate(7),
    start_time: '10:00',
    capacity: 50,
    spots_available: 25,
    status: 'active',
    zoom_link: 'https://zoom.us/j/777888999',
    class_name: 'Yoga por Zoom',
    location_name: 'Virtual',
  },
  {
    id: '12',
    class_type_id: '3',
    location_id: '1',
    session_date: getFutureDate(4),
    start_time: '18:00',
    capacity: 1,
    spots_available: 1,
    status: 'active',
    class_name: 'Clase Privada Presencial',
    location_name: 'Estudio Norte',
  },
]

export const mockBookings = [
  {
    id: '1',
    student_name: 'Ana García',
    student_email: 'ana@ejemplo.com',
    class_name: 'Yoga Grupal Presencial',
    session_date: getFutureDate(1),
    start_time: '08:00',
    amount_paid: 1,
    payment_status: 'paid',
    booking_status: 'confirmed',
  },
  {
    id: '2',
    student_name: 'Carlos López',
    student_email: 'carlos@ejemplo.com',
    class_name: 'Yoga por Zoom',
    session_date: getFutureDate(1),
    start_time: '10:00',
    amount_paid: 1,
    payment_status: 'paid',
    booking_status: 'confirmed',
  },
  {
    id: '3',
    student_name: 'María Fernanda',
    student_email: 'maria@ejemplo.com',
    class_name: 'Yoga Grupal Presencial',
    session_date: getFutureDate(2),
    start_time: '09:00',
    amount_paid: 1,
    payment_status: 'pending',
    booking_status: 'confirmed',
  },
  {
    id: '4',
    student_name: 'Juan Pérez',
    student_email: 'juan@ejemplo.com',
    class_name: 'Yoga Grupal Presencial',
    session_date: getFutureDate(-2),
    start_time: '08:00',
    amount_paid: 1,
    payment_status: 'paid',
    booking_status: 'attended',
  },
  {
    id: '5',
    student_name: 'Laura Torres',
    student_email: 'laura@ejemplo.com',
    class_name: 'Clase Privada Presencial',
    session_date: getFutureDate(-1),
    start_time: '18:00',
    amount_paid: 1,
    payment_status: 'refunded',
    booking_status: 'cancelled',
  },
  {
    id: '6',
    student_name: 'Roberto Gómez',
    student_email: 'roberto@ejemplo.com',
    class_name: 'Yoga por Zoom',
    session_date: getFutureDate(-3),
    start_time: '10:00',
    amount_paid: 1,
    payment_status: 'paid',
    booking_status: 'no_show',
  },
]
